import React from 'react';
import { Typography, Box, Link, Stack } from '@mui/material';
import { theme } from 'theme';
const IntegrationCard = ({
  image,
  title,
  subtitle,
  linkText,
  linkHref,
  buttonText,
  buttonVariant,
  buttonIcon,
  hrefButton,
  buttonId,
  chipText,
}) => {
  const iconColor =
    buttonVariant === 'outlined'
      ? theme.colors.primary.red
      : theme.colors.greyScale.white;

  return (
    <Stack
      direction="column"
      justifyContent="space-between"
      sx={{
        minHeight: 360,
        height: '100%',
        border: `1px solid ${theme.colors.greyScale.grey}`,
        backgroundColor: theme.colors.greyScale.white,
        paddingTop: image ? 0 : '20px',
        paddingBottom: '20px',
        paddingLeft: '15px',
        paddingRight: '15px',
      }}
    >
      <Box>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            justifyContent: 'space-between',
          }}
        >
          {image && (
            <img
              src={image}
              alt={title}
              style={{
                width: 90,
                height: 90,
                objectFit: 'contain',
                objectPosition: 'center',
              }}
            ></img>
          )}
          {linkText && buttonVariant === 'outlined' ? (
            <div
              style={{
                backgroundColor: '#E8FCF3',
                color: 'black',
                borderRadius: '25px',
                width: 'fit-content',
                display: 'flex',
                padding: '10px 15px',
                alignItems: 'center',
                gap: '10px',
                marginBottom: '16px',
                minWidth: '88px',
                maxHeight: '40px',
                justifyContent: 'center',
                alignSelf: 'center',
                fontSize: '14px',
              }}
            >
              <Typography
                variant="xs-bold"
                textAlign="center"
                fontFamily="Suisse-Intl"
                style={{ whiteSpace: 'nowrap', overflow: 'hidden' }}
              >
                {chipText}
              </Typography>
            </div>
          ) : (
            <></>
          )}
        </div>
        <Stack spacing={2} sx={{ marginBottom: 5, marginTop: 3 }}>
          <Typography
            variant="headline"
            sx={{ fontWeight: 600, color: '#333' }}
          >
            {title}
          </Typography>
          <Typography variant="body">{subtitle}</Typography>
        </Stack>
      </Box>

      <Stack spacing={2}>
        {linkText && (
          <Link
            href={linkHref}
            target="_blank"
            underline="hover"
            sx={{
              display: 'block',
              color: theme.colors.primary.black,
              textDecoration: 'underline !important',
            }}
          >
            <Typography
              variant="link2"
              sx={{ textDecoration: 'underline !important' }}
            >
              {linkText}
            </Typography>
          </Link>
        )}

        {buttonText && (
          <Link
            id={buttonId}
            href={hrefButton}
            target="_blank"
            variant={buttonVariant === 'outlined' ? 'outlined' : 'contained'}
            sx={{
              width: 'fit-content',
              minWidth: 180,
              minHeight: 45,
              padding: buttonVariant === 'outlined' ? '10px 40px' : '0px 0px',
              textDecoration: 'none',
              border:
                buttonVariant === 'outlined'
                  ? `1px solid ${theme.colors.primary.red}`
                  : 'none',
              backgroundColor:
                buttonVariant === 'outlined'
                  ? theme.colors.greyScale.white
                  : theme.colors.primary.red,
              color:
                buttonVariant === 'outlined'
                  ? theme.colors.primary.red
                  : theme.colors.greyScale.white,
              '&:hover': {
                backgroundColor:
                  buttonVariant === 'outlined'
                    ? theme.colors.primary.white
                    : '#B20B00',
                color:
                  buttonVariant === 'outlined'
                    ? '#B20B00'
                    : theme.colors.greyScale.white,
                borderColor:
                  buttonVariant === 'outlined'
                    ? '#B20B00'
                    : theme.colors.greyScale.white,
              },
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography variant="body" sx={{ textDecoration: 'none' }}>
              {buttonText}
            </Typography>
            {buttonVariant === 'outlined' ? (
              <></>
            ) : (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  ml: 2,
                  color: iconColor,
                }}
              >
                {React.cloneElement(buttonIcon, {
                  sx: { color: iconColor },
                })}
              </Box>
            )}
          </Link>
        )}
      </Stack>
    </Stack>
  );
};

export default IntegrationCard;
